module.exports = __webpack_public_path__ + "img/fukabtnBg.e7889863.png";